import { watch, onBeforeUnmount } from 'vue';
import { useDocumentVisibility, useIdle, useIntervalFn } from '@vueuse/core';
import ConversationViewersAPI from 'dashboard/api/conversationViewers';

// RedHosting: enquanto a conversa esta aberta na tela e o atendente mexeu nela nos
// ultimos 3 minutos, o servidor sabe que ela esta em atendimento e nao notifica os
// outros (lib/conversation_viewers.rb). A marca expira em 45s sem aviso.
const HEARTBEAT_MS = 20 * 1000;
const IDLE_MS = 3 * 60 * 1000;

// Falha de rede aqui so atrasa a marca; a proxima batida tenta de novo.
const ignoreError = () => {};

export function useConversationViewing(conversationId) {
  const { idle } = useIdle(IDLE_MS);
  const visibility = useDocumentVisibility();
  let viewingId = null;

  const leave = () => {
    if (!viewingId) return;
    ConversationViewersAPI.leave(viewingId).catch(ignoreError);
    viewingId = null;
  };

  const sync = () => {
    const id = conversationId.value;
    const attending = id && visibility.value === 'visible' && !idle.value;
    if (viewingId !== (attending ? id : null)) leave();
    if (!attending) return;

    viewingId = id;
    ConversationViewersAPI.touch(id).catch(ignoreError);
  };

  useIntervalFn(sync, HEARTBEAT_MS);
  watch([conversationId, visibility, idle], sync, { immediate: true });
  onBeforeUnmount(leave);
}
